export default "__VITE_ASSET__CK7K00fx__"